<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle28')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle28') }}</h1>
    <p>{{ $t('artText28-1') }}</p>
    <p>{{ $t('artText28-2') }}</p>
    <p>{{ $t('artText28-3') }}</p>
    <img
      :src="`${staticUrl}/images/blog/A_Comprehensive_Interior_Design_App_Suite_Ignite_Your_Design_Spark.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText28-4') }}</p>
    <p>{{ $t('artText28-5') }}</p>
    <p>{{ $t('artText28-6') }}</p>
    <p>{{ $t('artText28-7') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle17')}`,
  ogTitle: `${t('artSeoTitle17')}`,
  description: `${t('artSeoDesc17')}`,
  ogDescription: `${t('artSeoDesc17')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
